import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { transformRacePrizePool } from '../../../../helpers/transformRacePrizePool';

import './styles.scss';
import {FC} from "react";

const headers = ['place', 'type', 'prize'];
interface LeaderBoardProps {
    selectedRaceTab: Record<string, any>;
}


const PrizePool:FC<LeaderBoardProps> = ({selectedRaceTab}) => {
    const { t } = useTranslation();

    const prizePoolData = transformRacePrizePool(selectedRaceTab?.prizeStructure?.headers, selectedRaceTab?.prize_pool);

    const classes = cn('prize-pool', {
        'prize-pool--mobile': isMobile,
    });

    return (
        prizePoolData?.length ? (
            <div className={classes}>
                <div className="prize-pool__header">
                    {headers.map((item) => (
                        <div className="prize-pool__header__item">{t(item)}</div>
                    ))}
                </div>
                <div className="prize-pool__body">
                    {prizePoolData?.map((item, index) => (
                        <div
                            key={index}
                            className={cn('prize-pool__body__row', {
                                even: index % 2 === 0,
                                odd: index % 2 !== 0,
                            })}
                        >
                            <div className="prize-pool__item__place">
                                <span> {item.place}</span>
                            </div>
                            <div>{item.type}</div>
                            <div>{item.prize}</div>
                        </div>
                    ))}
                </div>
            </div>
        ) : <></>
    );
};

export default PrizePool;
